import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'localization';

const CatalogPlaceholder: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="org-settings-section">
      <header className="org-settings-section__header">
        <h2 className="org-settings-section__title">{t('orgSettings.catalog.title')}</h2>
        <p className="org-settings-section__subtitle">{t('orgSettings.catalog.description')}</p>
      </header>
      <div className="org-settings-section__empty">
        <i className="pi pi-th-large" aria-hidden="true" />
        <p>{t('orgSettings.placeholder.comingSoon')}</p>
        <Link to="/marketplace">{t('orgSettings.catalog.marketplaceLinkLabel')}</Link>
      </div>
    </div>
  );
};

export default CatalogPlaceholder;
